import { FirebaseApp, getApp, getApps, initializeApp } from "firebase/app";

type FirebaseConfigKey =
  | "apiKey"
  | "authDomain"
  | "projectId"
  | "storageBucket"
  | "messagingSenderId"
  | "appId"
  | "measurementId";

const firebaseConfig: Record<FirebaseConfigKey, string> = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? "",
};

const optionalKeys: FirebaseConfigKey[] = ["measurementId"];
const requiredKeys = (
  Object.keys(firebaseConfig) as FirebaseConfigKey[]
).filter((key) => !optionalKeys.includes(key));
const missingKeys = requiredKeys.filter((key) => !firebaseConfig[key]);

export const isFirebaseConfigured = missingKeys.length === 0;

const createFirebaseApp = (): FirebaseApp => {
  if (getApps().length > 0) {
    return getApp();
  }

  return initializeApp(firebaseConfig);
};

export const initializeFirebase = (): FirebaseApp | null => {
  if (!isFirebaseConfigured) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        `[Firebase] Missing env values: ${missingKeys.join(", ")}. Firebase is not initialized.`
      );
    }

    return null;
  }

  return createFirebaseApp();
};
